import React from "react";
import { Row, Col, Breadcrumb, Dropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaRegFileAlt } from "react-icons/fa";
import { RiHome6Line, RiArrowRightSLine } from "react-icons/ri";
import SubscriptionStats from "../../components/super-admin/Subscription/SubscriptionStats";
import SubscriptionList from "../../components/super-admin/Subscription/SubscriptionList";
const SubscriptionPage = () => {
  return (
    <div className="page-breadcrumb" style={{ padding: "15px", background: "#f8f9fa",   }} >
      <>
        {/* Internal CSS */}
        <style>
          {`
        // .page-breadcrumb{
         
        //   padding:15px 15px;
        //   border-radius:8px;
        //   margin-bottom:10px;
        // }

        .page-title{
          font-size:20px;
          font-weight:500;
          color:#1e293b;
        }

        .breadcrumb{
          font-size:14px;
          margin-bottom:0;
        }

        .breadcrumb-item a{
          text-decoration:none;
          color:#64748b;
        }

        // .export-btn{
        //   border:1px solid #e5e7eb;
        //   background:#fff;
        //   font-size:14px;
        //   font-weight:500;
        //   padding:8px 14px;
        //   border-radius:6px;
        // }

        // .export-btn:hover{
        //   background:#f1f5f9;
        // }

        .dropdown-menu{
          min-width:180px;
        }

        .dropdown-item{
          font-size:14px;
          padding:8px 12px;
        }

        .collapse-icon{
          font-size:20px;
          color:#475569;
          cursor:pointer;
        }

        @media(max-width:768px){

          .page-title{
            font-size:20px;
          }

          .right-content{
            margin-top:10px;
          }

        }
        `}
        </style>

        <div className="page-breadcrumb">
          <Row className="align-items-center justify-content-between">
            {/* LEFT SIDE */}
            <Col md={6} xs={12}>
              <div className="mb-3">
                {" "}
                {/* increased bottom margin for more breathing room */}
                <h2
                  className="page-title mb-2 "
                  style={{ fontSize: "1.6rem" }} // slightly larger title (adjust as needed)
                >
                  Subscription
                </h2>
                <Breadcrumb
                  className="custom-breadcrumb"
                  style={{
                    "--bs-breadcrumb-divider": "none", // remove default slash
                    fontSize: "1.1rem", // slightly larger text/icons overall
                  }}
                >
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
                    <RiHome6Line
                      className="mb-2"
                      style={{
                        fontSize: "1.2rem", // increased icon size
                        verticalAlign: "middle",
                        marginRight: "0.35rem",
                      }}
                    />
                    <RiArrowRightSLine></RiArrowRightSLine>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item>
                    Super Admin
                    <RiArrowRightSLine></RiArrowRightSLine>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item active>
                    <span className="rext-dark"> Subscription</span>
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>

            {/* RIGHT SIDE */}
            <Col
              md={6}
              xs={12}
              className="d-flex justify-content-md-end align-items-center flex-wrap right-content"
            >
              {/* Export Dropdown */}
              <Dropdown className="me-2 mb-2">
                <Dropdown.Toggle className="export-btn bg-transparent border border-1 d-inline-flex align-items-center text-dark">
                  <FaRegFileAlt className="fs-5 me-2" />
                  Export
                </Dropdown.Toggle>

                <Dropdown.Menu align="end">
                  <Dropdown.Item>
                    <FaRegFileAlt className="fs-5 me-2" />
                    Export as PDF
                  </Dropdown.Item>

                  <Dropdown.Item>
                    <FaRegFileAlt className="fs-5 me-2" />
                    Export as Excel
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              {/* Collapse Icon */}
              <Button variant="link" className="p-0" title="Collapse">
                <i className="ti ti-chevrons-up collapse-icon"></i>
              </Button>
            </Col>
          </Row>
        </div>
      </>
      <SubscriptionStats />
      <SubscriptionList />
    </div>
  );
};

export default SubscriptionPage;
